import PropTypes from 'prop-types';
import { MIN_NUMBER_OF_VOTES } from '../../../constants/settings';
import * as Styled from './Style';
const {
  I18n
} = global;
export const RATING_PRIORTY = ['punctuality', 'technical-condition', 'cleanless', 'politeness'];
const SegmentRating = ({
  rating
}) => {
  if (!(rating['votes-count'] >= MIN_NUMBER_OF_VOTES && rating['avg-rating'])) {
    return /*#__PURE__*/React.createElement(Styled.RatingAttention, null, I18n.t('components.Segment.rating_exception'));
  }
  return /*#__PURE__*/React.createElement(Styled.ListUnstyled, null, /*#__PURE__*/React.createElement(Styled.Title, null, I18n.t('components.Segment.rating_title', {
    count: rating['avg-rating']
  }), /*#__PURE__*/React.createElement(Styled.RatingVotes, null, I18n.t('components.Segment.rating_description', {
    count: rating['votes-count']
  }))));
};
SegmentRating.propTypes = {
  rating: PropTypes.object
};
export default SegmentRating;